//@ts-nocheck

import { FunctionalComponent, h } from "preact";
import { useState, useCallback, useEffect } from "preact/hooks";

import styled, { css } from "styled-components";
import { StatusButton } from "./statusButton";

const Row = styled.span`
  display: flex;
`;

const Options = styled(Row)``;

export const RadioButtons: FunctionalComponent = ({
  options,
  initial,
  onSelect,
  disableReselect,
  transformValue = (option) => option,
}) => {
  useEffect(() => {
    if (initial) {
      // const option = options.find((option) => option.label === initial);
      // handleClick(option)();
      setActive(initial);
    }
    return () => {};
  }, [initial]);

  const [active, setActive] = useState();

  const handleClick = (option) => () => {
    if (disableReselect && option.label === active) return;
    setActive(option.label);
    onSelect(transformValue(option));
  };

  return (
    <Options>
      {options.map((option: string, i: number) => (
        <StatusButton
          key={`${option.label}_${i}`}
          isActive={option.label === active}
          onClick={handleClick(option)}
        >
          {option.label}
        </StatusButton>
      ))}
    </Options>
  );
};
